import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Chat from './Chat';
import ModalNouvelleConsultation from './ModalNouvelleConsultation';
import ModalListePatients from './ModalListePatients';
import ModalConvPatient from './ModalConvPatient';

function Main({ API_URL, token, medecin, onLogout }) {
    const [convActive, setConvActive]               = useState(null);
    const [patientActif, setPatientActif]           = useState(null);
    const [sidebarOpen, setSidebarOpen]             = useState(false);
    const [modalNouvelle, setModalNouvelle]         = useState(false);
    const [modalPatients, setModalPatients]         = useState(false);
    const [patientHistorique, setPatientHistorique] = useState(null);
    const [refreshSidebar, setRefreshSidebar]       = useState(0);

    function ouvrirConversation(convId, patient) {
        setConvActive(convId);
        setPatientActif(patient);
        setSidebarOpen(false);
        setModalNouvelle(false);
        setModalPatients(false);
        setPatientHistorique(null);
    }

    return (
        <div style={{
            display: 'flex', width: '100vw', height: '100vh',
            overflow: 'hidden', position: 'fixed', top: 0, left: 0
        }}>
            {/* Overlay mobile */}
            {sidebarOpen && (
                <div
                    onClick = {() => setSidebarOpen(false)}
                    style={{
                        display: 'block', position: 'fixed', inset: 0,
                        background: 'rgba(0,0,0,0.6)', zIndex: 50
                    }}
                />
            )}

            {/* Sidebar */}
            <Sidebar
                API_URL      = {API_URL}
                token        = {token}
                medecin      = {medecin}
                convActive   = {convActive}
                sidebarOpen  = {sidebarOpen}
                refresh      = {refreshSidebar}
                onFermer     = {() => setSidebarOpen(false)}
                onLogout     = {onLogout}
                onOuvrirConv = {ouvrirConversation}
                onNouvelleConsultation = {() => {
                    setSidebarOpen(false);
                    setModalNouvelle(true);
                }}
                onListePatients = {() => {
                    setSidebarOpen(false);
                    setModalPatients(true);
                }}
            />

            {/* Zone principale */}
            <div style={{
                flex: 1, display: 'flex', flexDirection: 'column',
                height: '100vh', background: 'var(--bg)',
                minWidth: 0, overflow: 'hidden'
            }}>
                {/* Header mobile */}
                <div id="mobile-header-react" style={{
                    padding: '14px 16px',
                    borderBottom: '1px solid var(--border)',
                    alignItems: 'center', justifyContent: 'space-between',
                    background: 'var(--bg-light)', flexShrink: 0
                }}>
                    <button
                        onClick = {() => setSidebarOpen(true)}
                        style={{
                            background: 'none', border: 'none',
                            color: 'var(--text)', fontSize: '20px',
                            cursor: 'pointer', padding: '4px 8px',
                            borderRadius: '6px', lineHeight: 1
                        }}
                    >☰</button>
                    <span style={{ fontSize: '15px', fontWeight: 600, color: 'var(--white)' }}>
                        Agent Médical
                    </span>
                    <button
                        onClick = {() => setModalNouvelle(true)}
                        style={{
                            background: 'none', border: '1px solid var(--border)',
                            color: 'var(--text)', fontSize: '18px',
                            cursor: 'pointer', padding: '4px 10px',
                            borderRadius: '6px', lineHeight: 1
                        }}
                    >+</button>
                </div>

                {/* Écran accueil ou Chat */}
                {!convActive ? (
                    <div style={{
                        flex: 1, display: 'flex', flexDirection: 'column',
                        alignItems: 'center', justifyContent: 'center',
                        gap: '8px', padding: '24px'
                    }}>
                        <h2 style={{ fontSize: '22px', fontWeight: 500, color: 'var(--text)', textAlign: 'center' }}>
                            Bonjour, Dr. {medecin}
                        </h2>
                        <p style={{ fontSize: '14px', color: 'var(--text-muted)', textAlign: 'center' }}>
                            Sélectionnez une consultation ou créez-en une nouvelle
                        </p>
                    </div>
                ) : (
                    <Chat
                        API_URL         = {API_URL}
                        token           = {token}
                        convActive      = {convActive}
                        patientActif    = {patientActif}
                        onPatientUpdate = {p => setPatientActif(p)}
                    />
                )}
            </div>

            {/* Modal nouvelle consultation */}
            {modalNouvelle && (
                <ModalNouvelleConsultation
                    API_URL  = {API_URL}
                    token    = {token}
                    onFermer = {() => setModalNouvelle(false)}
                    onCreer  = {(conv, patient) => {
                        setRefreshSidebar(r => r + 1);
                        ouvrirConversation(conv.id, patient);
                    }}
                />
            )}

            {/* Modal liste patients */}
            {modalPatients && (
                <ModalListePatients
                    API_URL          = {API_URL}
                    token            = {token}
                    onFermer         = {() => setModalPatients(false)}
                    onVoirHistorique = {patient => {
                        setModalPatients(false);
                        setPatientHistorique(patient);
                    }}
                />
            )}

            {/* Modal conversations patient */}
            {patientHistorique && (
                <ModalConvPatient
                    API_URL      = {API_URL}
                    token        = {token}
                    patient      = {patientHistorique}
                    onFermer     = {() => setPatientHistorique(null)}
                    onOuvrirConv = {(convId, patient) => {
                        setPatientHistorique(null);
                        ouvrirConversation(convId, patient);
                    }}
                />
            )}
        </div>
    );
}

export default Main;